import dayjs from "dayjs";

export const SalesPersonWitHChallanDataJson = {

    screenTitle: "Sales Team Challan Wise Details",

    searchList: [
        {
            label: "From Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            dataKey: "fromdate",
            defaultValue: dayjs(),
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "todate-le",
        },
        {
            label: "To Date",
            controlType: "datepicker",
            placeHolder: "",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            defaultValue: dayjs(),
            dataKey: "todate",
            onSubmit: "compare",
            onSubmitParameter: "fromdate-ge",
            isMandatory: true,
            onSubmit: "compare",
            onSubmitParameter: "fromdate-ge",
            format: "DD-MM-YYYY",
            maxDatekey: 'fromdate',
            days: 31
        },
    ],
};